import { Injectable, NgModule } from "@angular/core";
import { DateAdapter, MAT_DATE_FORMATS, MAT_NATIVE_DATE_FORMATS, NativeDateAdapter } from "@angular/material/core";

export const DATALAB_DATE_FORMATS = {
    ...MAT_NATIVE_DATE_FORMATS,
    display: {
        ...MAT_NATIVE_DATE_FORMATS.display,
        dateInput: {
            year: '2-digit',
            month: 'short',
            day: '2-digit'
        }
    }
};

@Injectable()
export class DataLabDateAdapter extends NativeDateAdapter {
    format(date: Date, displayFormat: Object): string {
        if (date && displayFormat &&
            displayFormat['year'] === '2-digit' &&
            displayFormat['month'] === 'short' &&
            displayFormat['day'] === '2-digit') {
            const dtf = new Intl.DateTimeFormat(this.locale, displayFormat);

            const parts = dtf.formatToParts(date);
            const day = parts.find(p => p.type === 'day');
            const month = parts.find(p => p.type === 'month');
            const year = parts.find(p => p.type == 'year');

            return `${day.value}.${month.value}.${year.value}`;
        }

        return super.format(date, displayFormat);
    }
}

@NgModule({
    providers: [{ provide: DateAdapter, useClass: DataLabDateAdapter }]
})
export class DataLabDateModule { }

@NgModule({
    imports: [DataLabDateModule],
    providers: [{ provide: MAT_DATE_FORMATS, useValue: DATALAB_DATE_FORMATS }]
})
export class MatDataLabDateModule { }